export const featureIDs = [
    'acuity_integration',
    'amplitude_integration',
    'api_destinations',
    'automations_disabled',
    'calendly_integration',
    'campaign_filtering',
    'campaigns_disabled',
    'contact_groups',
    'external_contact_lists',
    'flows',
    'group_statuses',
    'hubspot_integration',
    'hybrid_message_routing',
    'message_hub_ai',
    'new_billing_implementation',
    'notifications',
    'omni_analytics',
    'quick_blast_ai',
    'revel_integration',
    'sentiment_analysis_ai',
    'shift_to_text',
    'skip_short_url_generation',
    'simple_message_hub',
    'single_sign_on',
    'subscriptions',
    'time_zone_aware_campaigns',
    'transactional_default',
] as const;

export type FeatureID = (typeof featureIDs)[number];
export type Features = Record<FeatureID, boolean>;
